{
  "version": 1,
  "asset_id": "6f99bf7a-e737-4633-b57d-570848843203",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/6f99bf7a-e737-4633-b57d-570848843203/renovatie-640.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/6f99bf7a-e737-4633-b57d-570848843203/renovatie-640.avif",
  "original_filename": "renovatie-640.avif",
  "size": 10397,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:03:36Z"
}
